import firebase from "firebase/app";
import "firebase/auth";
import "firebase/storage"

const firebaseConfig = {
    apiKey: process.env.VUE_APP_FIREBASE_API_KEY,
    authDomain: process.env.VUE_APP_FIREBASE_AUTH_DOMAIN,
    projectId: process.env.VUE_APP_FIREBASE_PROJECT_ID,
    storageBucket: process.env.VUE_APP_FIREBASE_STORAGE_BUCKET
};

firebase.initializeApp(firebaseConfig);

export const auth = firebase.auth();

// Explicitly set LOCAL persistence so the session survives browser restarts.
// Exported so the bootstrap can await it if needed.
export const persistenceReady = auth.setPersistence(firebase.auth.Auth.Persistence.LOCAL);

export default firebase;